import { nullable, struct } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Id as CustomerId } from '../../../customer/Id';
import { Id as OrganizationId } from '../../../organization/Id';

export const Request = struct({
	name: iotsUtils.NotEmptyString,
	organizationId: OrganizationId,
	customerId: nullable(CustomerId),
});
